<div class="ap-container mx-0 px-0">
  <div class="row gap-1 justify-content-between">
    @if (
      security.transactionType.transactionTypeId ===
      transactionTypes.GeneralRates
    ) {
      <div class="col-sm-12 col-md-4 col-lg-3">
        <b>{{ security.generalRateEntityType?.name }}</b>
        <p class="mb-0">{{ 'editTaxResultList.entityType' | translate }}</p>
      </div>
    } @else {
      <div class="col-sm-12 col-md-4 col-lg-3">
        <b>{{ security.entity.name }}</b>
        <p class="mb-0">{{ 'editTaxResultList.entity' | translate }}</p>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-3">
        <b>{{ security.entity.entityType.name }}</b>
        <p class="mb-0">{{ 'editTaxResultList.entityType' | translate }}</p>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-3">
        <b>{{ security.entity.residencyJurisdiction.country.name }}</b>
        <p class="mb-0">
          {{ 'editTaxResultList.residencyJurisdiction' | translate }}
        </p>
      </div>
    }
    <div class="col-sm-12 col-md-4 col-lg-3">
      <b>{{ security.investmentJurisdiction.country.name }}</b>
      <p class="mb-0">
        {{ 'editTaxResultList.investmentJurisdiction' | translate }}
      </p>
    </div>
    <div class="col-sm-12 col-md-4 col-lg-3">
      <b class="w-100 mb-2">{{ security.name }}&nbsp;</b>
      <p class="mb-0">{{ 'editTaxResultList.securityName' | translate }}</p>
    </div>
    <div class="col-sm-12 col-md-4 col-lg-3">
      <b>{{ security.securityType.name }}</b>
      <p class="mb-0">{{ 'editTaxResultList.securityType' | translate }}</p>
    </div>
    @if (
      security.transactionType.transactionTypeId ===
      transactionTypes.SpecificAdvice
    ) {
      <div class="col-sm-12 col-md-4 col-lg-3">
        <b>{{ security.acquisitionDate | date: 'MM/dd/yyyy' }}</b>
        <p class="mb-0">{{ 'editTaxResultList.acquireDate' | translate }}</p>
      </div>
    }
  </div>
</div>
